import React from 'react'
import NetherlandReqMain from './NetherlandReqMain'
import "./../../UaeAttestation/UaeReq/UaeReq.css";

function NetherlandReq() {
  return (
    <div className="uaeReqContainer">
      <NetherlandReqMain />
    </div>
  )
}

export default NetherlandReq
